import { IonToggle } from '@ionic/react';
import i18next from 'i18next';
import { useCallback } from 'react';
import { EntityFormField } from '../../interfaces/forms.interface';
import { TooltipInInput } from './TooltipInInput';

interface Props {
  field: EntityFormField<any>;
  formik: any;
  marginTop?: string;
  disabled?: boolean;
}

export const BToggle = ({ field, formik, marginTop = 'margin-t-38', disabled = false }: Props) => {
  const formValue = formik.values?.[field.name];

  const getTooltip = useCallback(() => {
    if (field.tooltip) {
      return <TooltipInInput value={field.tooltip} />;
    }
  }, [field.tooltip]);

  return (
    <div className={`width-300px ${marginTop}`}>
      <div className="g-toggle-container height-50px b-field-border border-radius-input positionRelative">
        {getTooltip()}
        <div className="sc-ion-label-md-s normalText4 border-radius-24">{i18next.t(`FORMS.${field.label}`)}</div>
        <IonToggle
          data-testid={`${field.name}_${formValue}`}
          disabled={field.disabled || disabled}
          name={field.name}
          mode="ios"
          checked={!!formValue}
          className="border-radius-24"
          value={formValue}
          onClick={() => formik.setFieldValue(field.name, !formValue)}></IonToggle>
      </div>
    </div>
  );
};
